import React from 'react';
import Modal from '../shared/Modal';
import ChefLocationList from './ChefLocationList';

class ChefLocationModal extends React.Component {
  state = {
    serviceDistricts: []
  };

  render() {
    const { isOpen, closeModal, availableServiceDistricts } = this.props;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className="admin-wrapper">
          <h2 className="h2 modal__heading">Preferred Locations</h2>
          <p className="p chef-location__list-label">
            Which locations are the chef willing to serve?
          </p>
          <ChefLocationList
            serviceDistricts={this.state.serviceDistricts}
            availableServiceDistricts={availableServiceDistricts}
            toggleDistrict={this.toggleDistrict}
            toggleGroup={this.toggleGroup}
            showSubDistricts={true}
          />

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="button"
                className="btn btn--solid-blue btn--full-width"
                value="Save"
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  toggleDistrict = district => {
    const districts = [...this.state.serviceDistricts];
    const index = districts.findIndex(sd => sd.id === district.id);

    let serviceDistricts = [];
    if (index >= 0) {
      // delete
      serviceDistricts = [
        ...districts.slice(0, index),
        ...districts.slice(index + 1, districts.length)
      ];
    } else {
      // add
      serviceDistricts = [...districts, district];
    }
    this.setState({ serviceDistricts });
  };

  toggleGroup = group => {
    const groupIds = group.service_district_subsections.map(d => d.id);
    const selectedIds = this.state.serviceDistricts.map(d => d.id);
    const doesContainAll = groupIds.every(id => selectedIds.includes(id));
    let serviceDistricts = [];

    if (doesContainAll) {
      // delete
      serviceDistricts = [
        ...this.state.serviceDistricts.filter(d => !groupIds.includes(d.id))
      ];
    } else {
      // add
      serviceDistricts = [
        ...this.state.serviceDistricts.filter(d => !groupIds.includes(d.id)),
        ...group.service_district_subsections
      ];
    }

    this.setState({ serviceDistricts });
  };

  handleSubmit = () => {
    const { serviceDistricts: service_district_subsections = [] } = this.state;
    this.props.updateChef({ service_district_subsections });
  };

  componentDidMount() {
    // initialize state from props
    this.deriveState();
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (
      this.props.serviceDistricts !== prevProps.serviceDistricts ||
      (this.props.isOpen && this.props.isOpen !== prevProps.isOpen)
    )
      this.deriveState();
  }

  deriveState() {
    this.setState({ serviceDistricts: this.props.serviceDistricts });
  }
}

export default ChefLocationModal;



// WEBPACK FOOTER //
// ./src/components/chef/ChefLocationModal.js